import React from 'react'
import { LuUser } from 'react-icons/lu'

import QuestionSection from '@/components/modals/LogReferralModal/components/QuestionSection'
import SelectCompanyIndividuals from '@/components/select/SelectCompanyIndividuals'
import { Checkbox } from '@/components/ui/checkbox'
import { Field, FieldContent, FieldLabel } from '@/components/ui/field'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import {
  selectLogData,
  updateLogData,
} from '@/redux/slices/logHistoricalReferral'

interface Props {
  disabled: boolean
}

const SelectToCompanyUsers: React.FC<Props> = ({ disabled }) => {
  const currentCompany = useCurrentCompanyOrFail()
  const logData = useAppSelector(selectLogData)
  const numAdvisers = logData.selectedToCompanyUsers.length
  const dispatch = useAppDispatch()

  function getSendEmailCheckboxText() {
    switch (true) {
      case numAdvisers > 1:
        return 'Send an email to the advisers?'
      case numAdvisers === 1:
        return 'Send an email to the adviser?'
      default:
        return 'Send an email to the adviser(s)?'
    }
  }

  return (
    <QuestionSection
      title="Who would you like to handle this referral?"
      icon={<LuUser />}
    >
      <div className="flex flex-col gap-2">
        <SelectCompanyIndividuals
          company={currentCompany}
          selected={logData.selectedToCompanyUsers}
          onSelect={(individuals) => {
            dispatch(updateLogData({ selectedToCompanyUsers: individuals }))
          }}
          isDisabled={disabled}
        />

        <Field orientation="horizontal" className="gap-x-1.5">
          <Checkbox
            id="send-email-to-advisers"
            name="send-email-to-advisers"
            defaultChecked
            onCheckedChange={(checked) => {
              dispatch(updateLogData({ shouldNotifyToCompanyUsers: !!checked }))
            }}
            disabled={disabled}
          />
          <FieldContent>
            <FieldLabel
              htmlFor="send-email-to-advisers"
              className="text-muted-foreground"
            >
              {getSendEmailCheckboxText()}
            </FieldLabel>
          </FieldContent>
        </Field>
      </div>
    </QuestionSection>
  )
}

export default SelectToCompanyUsers
